import type { FC } from 'react';

import { Indicator } from './styled';

import { IconName } from '../../../Icon';

interface ISortIndicator {
    isSorted: boolean;
    isSortedAsc: boolean;
}

export const SortIndicator: FC<ISortIndicator> = (props) => (
    <Indicator iconName={IconName.SORT} {...props} />
);
